import { mergeAttributes } from "@tiptap/core";
import { TableHeader as OriginalTableHeader } from "@tiptap/extension-table";

import type { TableHeaderOptions } from "@tiptap/extension-table";

export const TableHeader = OriginalTableHeader.extend<TableHeaderOptions>({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class:
          "relative p-0 border-b border-b-transparent before:content-[''] before:absolute before:right-[-4px] before:top-0 before:bottom-[-1px] before:w-2 before:cursor-col-resize before:z-20 last:before:hidden [[aria-readonly='true']_&]:before:hidden after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:right-[-1px] after:h-2 after:cursor-row-resize after:z-10 [[aria-readonly='true']_&]:after:hidden",
      },
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      size: {
        default: null,
      },
      color: {
        default: null,
      },
    };
  },

  renderHTML({ node, HTMLAttributes }) {
    const size = node.attrs.size as string | null;
    const color = node.attrs.color as string | null;
    const classes = [
      "table-cell-fill",
      size ? `text-size-${size}` : null,
      color ? `text-${color}` : null,
    ]
      .filter(Boolean)
      .join(" ");

    return [
      "th",
      mergeAttributes(
        this.options.HTMLAttributes,
        HTMLAttributes,
        classes ? { class: classes } : {},
      ),
      [
        "div",
        { class: "p-1 h-full table-cell-wrapper" },
        ["div", { class: "flex-1 [&>p]:m-0" }, 0],
      ],
    ];
  },
});
